import {AppConfig} from "@/comunes/helpers/AppConfig";

export default class ImagenesServicio {

    static imgTipoSolucionConstructivaS3(codigo) {
        codigo = codigo.toLowerCase();
        return `${AppConfig.S3_URL}/soluciones_constructivas/tipos/${codigo}.png`;
    }

    static imgMaterial(codigoSolucionConstructiva, referenciaMaterial) {
        let tipo = "";
        codigoSolucionConstructiva = codigoSolucionConstructiva.toLowerCase();
        switch (codigoSolucionConstructiva) {
            case "horizontal":
            case "vertical":
            case "fachada":
            case "urbano":
                tipo = codigoSolucionConstructiva;
                break;
            case "obra_nueva_urbano":
                tipo = "urbano";
                break;
            case "obra_nueva_horizontal":
            case "horizontal_rehabilitation":
                tipo = "horizontal";
                break;
            case "obra_nueva_vertical":
            case "vertical_rehabilitation":
                tipo = "vertical";
                break;
            case "obra_nueva_fachada":
            case "facade_rehabilitation":
                tipo = "fachada";
                break;
            case "obra_nueva_exterior":
            case "rehabilitacion_exterior":
                tipo = "exterior";
                break;
        }

        let referencia = encodeURIComponent(referenciaMaterial.replace(/\[/g, "").replace(/]/g, ""));

        return `${AppConfig.S3_URL}/materiales/${tipo}/${referencia}.png`;
    }

    static imgSolucionConstructiva(solCons) {
        if (solCons.referencia == null) return null;

        let referencia = encodeURIComponent(solCons.referencia.replace(/\[/g, "").replace(/]/g, ""));

        return `${AppConfig.S3_URL}/soluciones_constructivas/referencias/${solCons.tipoSolucion.codigo}/${referencia}.png`;
    }

    static urlImagen(url) {
        return `${AppConfig.S3_URL}${url}`;
    }
}